import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { BovBmfModel } from '@dto/custody-model-bov-bmf';
import { BilletInputConfigModel } from '@model/billet-input-config.model';
import { SideEnum } from '@model/enum/side.enum';
import { TimeInForceEnum } from '@model/enum/time-in-force.enum';
import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { SimpleOrder } from '@model/simpleOrder';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { SidebarService } from '@services/sidebar.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-billet-wks-inputs',
  templateUrl: './billet-wks-inputs.component.html'
})
export class BilletWksInputsComponent implements OnInit, OnChanges {

  @Input() symbol: string;
  @Input() messageQuote: MessageQuote = new MessageQuote();
  @Input() model: SimpleOrder = new SimpleOrder();
  @Input() billetOrder: string;
  @Input() typeOrder: TypeOrderEnum;
  @Input() sideOrder: SideEnum;
  @Input() stopLoss = false;
  @Input() stopGain = false;
  @Input() strategyOptions = [];
  @Input() typeOrderOptions = [];
  @Input() auctionHammer: boolean;
  @Input() loadValueService: boolean;
  @Input() isBilletFloat: boolean;
  @Input() listPosition: BovBmfModel = new BovBmfModel();
  @Input() withBackground: boolean;
  @Input() typeOrderSelected: BilletInputConfigModel = new BilletInputConfigModel();
  @Output() openConfirmationBillit = new EventEmitter<any>();
  @Input() financialAccount: any = {};
  configInput = [];
  loadingBtn: boolean;
  tabChangeTypeOrder = 0;
  isBuy = true;
  btnColor = 'buy';
  initialPrice = false;
  tickSize = Constants.BILLET_TICKSIZE_DEFAULT;
  timeInForceOptions = Constants.TIME_IN_FORCES.filter(option => option.showInBillet);
  minDate: Date = new Date();
  minDate2: Date = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate());
  qtdValid = true;
  lastTrade: number;
  indiceFuture: boolean;
  minimumAmount = 1;
  minimumIncrement = '0.01';
  msgOffline = Constants.MSG_OFFLINE_NEGOTIATION_01;
  msgQuoteInvalid = Constants.WORKSPACE_MSG005;
  isLoggedNegotiation: boolean;
  isOrderStopSimultaneous = this._configService.isTypeBilletStopSimultaneousOrOco();
  showConfirmationBillit: boolean;
  isStop = false;
  lossTrigger = false;
  lossLimit = false;
  gainTrigger = false;
  gainLimit = false;
  messageStopLoss: string;
  messageStopGain: string;
  whiteLabel = this._configService.getConfigWhitelabel();
  checkMarket: boolean;
  showOptions: boolean;
  showStopLoss = true;
  showStopGain: boolean;
  timeInForceEnum = TimeInForceEnum;
  typesOptions = [
    { id: TypeOrderEnum.LIMITED, text: Constants.TYPE_ORDER_TEXTS.Limited },
    { id: TypeOrderEnum.MARKETPROTECTED, text: Constants.TYPE_ORDER_TEXTS.MarketProtected },
    { id: TypeOrderEnum.MARKET, text: Constants.TYPE_ORDER_TEXTS.Market },
  ];
  priceValuesFormatOptions = Constants.PRICE_VALUES_FORMAT_OPTIONS;
  priceValuesFormatOptionsFuture = Constants.PRICE_VALUES_FORMAT_OPTIONS_FUTURES;

  constructor(
    private _render2: Renderer2,
    private _notificationService: NotificationsService,
    private _sidebarService: SidebarService,
    private _configService: ConfigService
  ) {
    this.setMessagesStop();
    this._configService.authHbLogged$
      .subscribe(loggedNegotiation => {
        if (loggedNegotiation) {
          this.isLoggedNegotiation = true;
        } else {
          this.isLoggedNegotiation = false;
        }
      });

  }

  ngOnChanges(elem: SimpleChanges) {
    if (elem.symbol && !elem.symbol.currentValue) {
      this.resetForm();
    } else if (elem.symbol && this.symbol && elem.symbol.currentValue
      && this.symbol.toLowerCase().trim() === elem.symbol.currentValue.toLowerCase().trim()) {
      this.model.quote = elem.symbol.currentValue;
    }
    if (elem.typeOrder && elem.typeOrder.currentValue && elem.typeOrder.previousValue) {
      this.model.type = elem.typeOrder.currentValue;
      this.isBuy = this.model.side === SideEnum.BUY ? true : false;
      if (this.model.type === TypeOrderEnum.STOP || this.model.type === TypeOrderEnum.STOP_LOSS) {
        this.isStop = true;
        this.lossTrigger = false;
        this.lossLimit = false;
        this.gainTrigger = false;
        this.gainLimit = false;
        this.stopLoss = true;
        this.model.stopLoss = this.stopLoss;
        this.stopGain = this.model.type === TypeOrderEnum.STOP_LOSS ? false : true;
        this.model.stopGain = this.stopGain;
        this.tooltipValidator();
        this.setMessagesStop();
        if (this.isStop && !this.model.stopLoss) {
          setTimeout(() => { this.setStopLoss(this.stopLoss); }, 0);
        }
        if (this.isStop && !this.model.stopGain) {
          setTimeout(() => { this.setStopGain(this.stopGain); }, 0);
        }
      } else {
        this.lossTrigger = true;
        this.lossLimit = true;
        this.gainTrigger = true;
        this.gainLimit = true;
        this.isStop = false;
        this.checkMarket = this.model.type === TypeOrderEnum.MARKET ? true : false;
      }
    }
    if (elem.sideOrder) {
      this.loadingBtn = true;
      if (elem.sideOrder && elem.sideOrder.currentValue && !elem.sideOrder.previousValue) {
        this.model.side = elem.sideOrder.currentValue;
      } else if (elem.sideOrder && elem.sideOrder.currentValue && elem.sideOrder.previousValue) {
        if (elem.sideOrder.currentValue !== elem.sideOrder.previousValue) {
          this.model.side = elem.sideOrder.currentValue;
        }
        this.configsInputTypeOrder(this.model.type);
      }
      if (this.model.side === SideEnum.BUY) {
        this.isBuy = true;
      } else {
        this.isBuy = false;
      }
      if (this.model.type === TypeOrderEnum.STOP || this.model.type === TypeOrderEnum.STOP_LOSS) {
        this.tooltipValidator();
        this.setMessagesStop();
      }
      setTimeout(() => {
        this.loadingBtn = false;
      }, 500);
    }
    if (elem.strategyOptions && elem.strategyOptions.currentValue && elem.strategyOptions.currentValue.length >= 2) {
      const defaultStrategy = elem.strategyOptions.currentValue.findIndex(strategy => strategy.orderStrategy == this.whiteLabel.billet.orderStrategy);
      this.model.orderStrategy = defaultStrategy != -1 ? elem.strategyOptions.currentValue[defaultStrategy].orderStrategy : null;
    }
    if (elem.messageQuote &&
      ((elem.messageQuote.currentValue && elem.messageQuote.currentValue.symbol) && !elem.messageQuote.previousValue) &&
      (this.model.quote && this.model.quote.toLowerCase().trim() === elem.messageQuote.currentValue.symbol.toLowerCase().trim())
    ) {
      this.messageQuote = elem.messageQuote.currentValue;
      this.initialPrice = this.model.closeConfirmation ? false : true;
      this.configBillet();
    } else if (elem.messageQuote && (elem.messageQuote.currentValue && elem.messageQuote.currentValue.symbol)
      && (elem.messageQuote && elem.messageQuote.previousValue && !elem.messageQuote.previousValue.symbol)) {
      if (this.model.quote.toLowerCase().trim() === elem.messageQuote.currentValue.symbol.toLowerCase().trim()) {
        this.messageQuote = elem.messageQuote.currentValue;
        this.initialPrice = this.model.closeConfirmation ? false : true;
        this.configBillet();
      }
    }
    if (elem.listPosition && elem.listPosition.currentValue) {
      this.listPosition = elem.listPosition.currentValue;
    }
    if (elem.typeOrderSelected) {
      this.model.type = elem.typeOrderSelected.currentValue.webFeeder;
      this.configInput = elem.typeOrderSelected.currentValue.inputsConfig;
    }
  }

  ngOnInit() {
    if (this.strategyOptions && this.strategyOptions.length > 0) {
      if (this.strategyOptions && this.strategyOptions.length >= 2) {
        const defaultStrategy = this.strategyOptions.findIndex(strategy => strategy.orderStrategy == this.whiteLabel.billet.orderStrategy);
        this.model.orderStrategy = defaultStrategy != -1 ? this.strategyOptions[defaultStrategy].orderStrategy : null;
      }
    }
    this.showConfirmationBillit = false;
  }

  configBillet() {
    if (this.messageQuote) {
      if (this.messageQuote.symbol.indexOf('win') === 0 || this.messageQuote.symbol.indexOf('wdo') === 0 ||
        this.messageQuote.symbol.indexOf('dol') === 0 || this.messageQuote.symbol.toLowerCase().indexOf('ind') === 0) {
        this.indiceFuture = true;
      } else {
        this.indiceFuture = false;
      }
      if (this.messageQuote.tickSize !== null && this.messageQuote.tickSize !== undefined) {
        this.tickSize = this.messageQuote.tickSize;
        this.priceValuesFormatOptionsFuture.precision = this.tickSize;
      } else {
        this.tickSize = 2;
        this.priceValuesFormatOptions.precision = this.tickSize;
      }
      let priceTemp: any;
      if (this.initialPrice) {
        if (this.loadValueService && this.model.qtd > 0) {
          this.model.qtd = this.model.qtd;
        } else if (this.messageQuote.loteDefault > 0) {
          this.model.qtd = this.messageQuote.loteDefault;
        } else {
          this.model.qtd = 0;
        }
        if (this.loadValueService && this.model.price) {
          priceTemp = this.model.price;
        } else {
          if (this.model.side === SideEnum.BUY && this.messageQuote.ask && this.messageQuote.ask.toString() !== '-') {
            priceTemp = this.messageQuote.ask.toString().replace('.', '');
          } else if (this.model.side === SideEnum.SELL && this.messageQuote.bid && this.messageQuote.bid.toString() !== '-') {
            priceTemp = this.messageQuote.bid.toString().replace('.', '');
          } else {
            priceTemp = this.messageQuote.lastTrade ? this.messageQuote.lastTrade.toString().replace('.', '') : 0;
          }
        }
        this.model.price = AppUtils.convertNumber(priceTemp);
        this.model.price = AppUtils.convertToNumber(this.model.price.toString(), this.messageQuote.tickSize);
        this.model.stoptrigger = this.model.price;
        this.model.stoplimit = this.model.price;
        this.model.targettrigger = this.isOrderStopSimultaneous ? this.model.price : 0;
        this.model.targetlimit = this.model.price;
        this.initialPrice = false;
        this.model.validityOrder = new Date();
        this.model.market = this.messageQuote.marketType;
        this.initialPrice = false;
        this.loadValueService = false;
      }
      if (this.messageQuote.loteDefault) {
        this.model.loteDefault = this.messageQuote.loteDefault;
      }
      if (this.messageQuote.minimumIncrement === undefined || !this.messageQuote.minimumIncrement) {
        this.minimumIncrement = '0.01';
      } else {
        this.minimumIncrement = this.messageQuote.minimumIncrement.toString().replace(',', '.');
      }

      this.model.total = (this.model.price * this.model.qtd) / (AppUtils.convertNumberAux(this.messageQuote.quotationForm as any) * AppUtils.convertNumberAux(this.messageQuote.contractMultiplier as any))
      this.checkMarket = this.model.type === TypeOrderEnum.LIMITED ? false : true;
      this.verifyQuantity();
      if (!this.model.stopLoss) {
        setTimeout(() => {
          this.setStopLoss(this.stopLoss);
        }, 0);
      }
      if (!this.model.stopGain) {
        setTimeout(() => {
          this.setStopGain(this.stopGain);
        }, 0);
      }
    }
  }

  tooltipValidator() {
    this.lastTrade = this.messageQuote.lastTrade.toString().split(',').length > 1
      ? AppUtils.convertNumber(this.messageQuote.lastTrade.toString().replace('.', '')) : this.messageQuote.lastTrade;
    if (this.isBuy && (this.model.type === TypeOrderEnum.STOP || this.model.type === TypeOrderEnum.STOP_LOSS)) {
      if (this.stopLoss) {
        if ((this.model.stoptrigger <= this.lastTrade) || (this.model.stoplimit < this.model.stoptrigger)) {
          if ((this.model.stoptrigger <= this.lastTrade)) {
            this.lossTrigger = false;
          } else {
            this.lossTrigger = true;
          }
          if (this.model.stoplimit < this.model.stoptrigger) {
            this.lossLimit = false;
          } else {
            this.lossLimit = true;
          }
        } else if (this.model.stoplimit === 0) {
          this.lossLimit = false;
        } else if (this.model.stoptrigger === 0) {
          this.lossTrigger = false;
        } else {
          this.lossTrigger = true;
          this.lossLimit = true;
        }
      }
      if (this.stopGain) {
        if (this.isOrderStopSimultaneous
          && ((this.model.targettrigger >= this.lastTrade) || (this.model.targetlimit < this.model.targettrigger))) {
          if (this.model.targettrigger >= this.lastTrade) {
            this.gainTrigger = false;
          } else {
            this.gainTrigger = true;
          }
          if (this.model.targetlimit < this.model.targettrigger) {
            this.gainLimit = false;
          } else {
            this.gainLimit = true;
          }
        } else if (!this.isOrderStopSimultaneous && this.model.targetlimit > this.lastTrade) {
          this.gainLimit = false;
        } else if (this.isOrderStopSimultaneous && this.model.targettrigger === 0) {
          this.gainTrigger = false;
        } else {
          this.gainTrigger = true;
          this.gainLimit = true;
        }
      }
    } else if (!this.isBuy && (this.model.type === TypeOrderEnum.STOP || this.model.type === TypeOrderEnum.STOP_LOSS)) {
      if (this.stopLoss) {
        if ((this.model.stoptrigger >= this.lastTrade) || (this.model.stoplimit > this.model.stoptrigger)) {
          this.lossTrigger = this.model.stoptrigger >= this.lastTrade ? false : true;
          this.lossLimit = this.model.stoplimit > this.model.stoptrigger ? false : true;
        } else {
          this.lossTrigger = true;
          this.lossLimit = true;
        }
      }
      if (this.stopGain) {
        if (this.isOrderStopSimultaneous
          && ((this.model.targettrigger <= this.lastTrade) || (this.model.targetlimit > this.model.targettrigger))) {
          this.gainTrigger = this.model.targettrigger <= this.lastTrade ? false : true;
          this.gainLimit = this.model.targetlimit > this.model.targettrigger ? false : true;
        } else if (!this.isOrderStopSimultaneous && this.model.targetlimit < this.lastTrade) {
          this.gainLimit = false;
        } else {
          this.gainTrigger = true;
          this.gainLimit = true;
        }
      }
    }
  }

  configsInputTypeOrder(value) {
    if (value) {
      const index = this.typeOrderOptions.findIndex(x => x.webFeeder === value);
      if (index >= 0) {
        this.model.type = this.typeOrderOptions[index].webFeeder;
        this.configInput = this.typeOrderOptions[index].inputsConfig;
        if (this.isStop && !this.model.stopLoss) {
          setTimeout(() => { this.setStopLoss(this.stopLoss); }, 0);
        }
        if (this.isStop && !this.model.stopGain) {
          setTimeout(() => { this.setStopGain(this.stopGain); }, 0);
        }
      }
    }
  }

  setSelectYPosition(event) {
    if (event) {
      const element = document.getElementsByClassName('cdk-overlay-pane');
      if (element && element.length > 0) {
        for (let i = 0; i < element.length; i++) {
          if (element[i].children[0] && element[i].children[0].classList.contains('buy-sell-options')) {
            let tempStyle = element[i]['style'].cssText;
            if (tempStyle && tempStyle.indexOf('transform:translateY(0)') == -1) {
              tempStyle = tempStyle.replace(/translateY\(.*\)/, 'translateY(0)');
              element[i].setAttribute('style', tempStyle);
            }
          }
        }
      }
    }
  }

  validPrice(value: number) {
    if (value < 0) {
      return this.model.price = this.model.price * -1;
    }
    if (this.model.price > 999999) {
      return this.model.price = 999999;
    } else if (this.model.targetlimit > 999999) {
      return this.model.targetlimit = 999999;
    } else if (this.isOrderStopSimultaneous && this.model.targettrigger > 999999) {
      return this.model.targettrigger = 999999;
    } else if (this.model.stoplimit > 999999) {
      return this.model.stoplimit = 999999;
    } else if (this.model.stoptrigger > 999999) {
      return this.model.stoptrigger = 999999;
    } else if (this.model.maxfloor > 9999999) {
      return this.model.maxfloor = 9999999;
    } else if (this.model.minqtd > 999999) {
      return this.model.minqtd = 999999;
    } else if (this.model.qtd > 999999) {
      return this.model.qtd = 999999;
    }
  }

  verifyPrice() {
    if (this.model && this.model.quote && this.model.quote.length >= 5
      && this.model.type && this.model.type.includes(this.typesOptions[0].id) && this.symbol) {
      return this.checkMarket || this.model.timeInForce === this.timeInForceEnum.GFA
        || this.model.timeInForce === this.timeInForceEnum.ATC ? false : true;
    }
  }

  verifyQuantity() {
    if (this.model.type === TypeOrderEnum.STOP || this.model.type === TypeOrderEnum.STOP_LOSS) {
      this.tooltipValidator();
    }
    if (this.model.price < 0) {
      this.model.price = this.model.price * -1;
    }
    if (this.model.qtd < 0) {
      this.model.qtd = this.model.qtd * -1;
    }
    let classDecrement;
    let classIncrement;
    if (document.getElementsByClassName('billet-wks-inputs')[0]) {
      classDecrement = document.getElementsByClassName('billet-wks-inputs')[0].getElementsByClassName('billet')[0]
        .getElementsByClassName('scroll-body')[0].getElementsByClassName('decrement')[0];
      classIncrement = document.getElementsByClassName('billet-wks-inputs')[0].getElementsByClassName('billet')[0]
        .getElementsByClassName('scroll-body')[0].getElementsByClassName('increment')[0];
    }
    if (Number(this.model.qtd) < this.minimumAmount) {
      this.qtdValid = false;
      if (classDecrement) {
        this._render2.addClass(classDecrement, 'decrement-invalid');
      }
      if (classIncrement) {
        this._render2.addClass(classIncrement, 'increment-invalid');
      }
    } else {
      this.qtdValid = true;
      if (classDecrement) {
        this._render2.removeClass(classDecrement, 'decrement-invalid');
      }
      if (classIncrement) {
        this._render2.removeClass(classIncrement, 'increment-invalid');
      }
    }
    this.model.total = (this.model.price * this.model.qtd) / (AppUtils.convertNumberAux(this.messageQuote.quotationForm as any) * AppUtils.convertNumberAux(this.messageQuote.contractMultiplier as any))
    this.model.totalLoss = (this.model.stoptrigger * this.model.qtd) / (AppUtils.convertNumberAux(this.messageQuote.quotationForm as any) * AppUtils.convertNumberAux(this.messageQuote.contractMultiplier as any))
    this.model.totalGain = this.isOrderStopSimultaneous ? (this.model.targettrigger * this.model.qtd) / (AppUtils.convertNumberAux(this.messageQuote.quotationForm as any) * AppUtils.convertNumberAux(this.messageQuote.contractMultiplier as any)) : 0;
  }

  quantityDisabled() {
    if (this.symbol == null) {
      return false;
    } else {
      return true;
    }
  }

  resetDate() {
    this.model.validityOrder = new Date();
  }

  resetForm() {
    this.model.timeInForce = this.timeInForceOptions[0].webfeeder;
    if (this.strategyOptions && this.strategyOptions.length > 0) {
      if (this.strategyOptions && this.strategyOptions.length >= 2) {
        const defaultStrategy = this.strategyOptions.findIndex(strategy => strategy.orderStrategy == this.whiteLabel.billet.orderStrategy);
        this.model.orderStrategy = defaultStrategy != -1 ? this.strategyOptions[defaultStrategy].orderStrategy : null;
      }
    }
    this.model.timeInForce = 'DAY';
    this.model.validityOrder = new Date();
    this.model.type = this.isStop ? TypeOrderEnum.STOP : TypeOrderEnum.LIMITED;
    this.model.stoptrigger = 0;
    this.model.stoplimit = 0;
    this.model.targettrigger = 0;
    this.model.targetlimit = 0;
    this.model.maxfloor = 0;
    this.model.minqtd = 0;
    this.model.price = 0;
    this.model.qtd = 0;
    this.model.totalGain = 0;
    this.model.totalLoss = 0;
    this.minimumIncrement = '0.01';
    this.model.timeInForce = this.timeInForceOptions[0].webfeeder;
    this.qtdValid = true;
    this.minimumAmount = 0;
    this.stopLoss = this.isStop ? true : false;
    this.model.stopLoss = this.stopLoss;
    this.stopGain = this.isStop ? true : false;
    this.checkMarketType();
    this.model.stopGain = this.stopGain;
    if (!this.model.stopLoss) {
      setTimeout(() => { this.setStopLoss(this.stopLoss); }, 0);
    }
    if (!this.model.stopGain) {
      setTimeout(() => { this.setStopGain(this.stopGain); }, 0);
    }
    this.verifyQuantity();
  }

  openModalConfirm() {
    if (!this.validLoggedNegotiation()) {
      return;
    }
    if (this.model.timeInForce === this.timeInForceEnum.GFA || this.model.timeInForce === this.timeInForceEnum.ATC) {
      this.model.type = TypeOrderEnum.MARKETPROTECTED;
      this.typeOrder = this.model.type;
    }
    this.model.showConfirmationBillit = true;
    this.openConfirmationBillit.emit(this.model);
  }

  setStopLoss(value: boolean) {
    if (this.model.stoptrigger == null) {
      this.model.stoptrigger = 0;
    }
    if (this.model.stoplimit == null) {
      this.model.stoplimit = 0;
    }
    this.stopLoss = value;
    const fieldGain = document.getElementById('stop-gain-content-wks');
    const fieldLoss = document.getElementById('stop-loss-content-wks');
    if (!this.stopGain && !this.stopLoss) {
      const elem1 = document.getElementById('gain-toggle-wks');
      if (elem1) {
        elem1.className = 'mat-slide-toggle toggle-on';
      }
      if (fieldGain) {
        fieldGain.style.opacity = '1';
      }
      const elem2 = document.getElementById('loss-toggle-wks');
      if (elem2) {
        elem2.className = 'mat-slide-toggle toggle-off';
      }
      if (fieldLoss) {
        fieldLoss.style.opacity = '0.5';
      }
      this.lossTrigger = true;
      this.lossLimit = true;
    } else {
      if (this.stopLoss) {
        const elem = document.getElementById('loss-toggle-wks');
        if (elem) {
          elem.className = 'mat-slide-toggle toggle-on';
        }
        if (fieldLoss) {
          fieldLoss.style.opacity = '1';
        }
        this.tooltipValidator();
      } else {
        const elem = document.getElementById('loss-toggle-wks');
        if (elem) {
          elem.className = 'mat-slide-toggle toggle-off';
        }
        if (fieldLoss) {
          fieldLoss.style.opacity = '0.5';
        }
        this.lossTrigger = true;
        this.lossLimit = true;
      }
    }
    this.model.stopLoss = this.stopLoss;
    this.model.stopGain = this.stopGain;
    this.setMessagesStop();
  }

  setStopGain(value: boolean) {
    if (this.isOrderStopSimultaneous && this.model.targettrigger == null) {
      this.model.targettrigger = 0;
    }
    if (this.model.targetlimit == null) {
      this.model.targetlimit = 0;
    }
    this.stopGain = value;
    const fieldGain = document.getElementById('stop-gain-content-wks');
    const fieldLoss = document.getElementById('stop-loss-content-wks');
    if (!this.stopGain && !this.stopLoss) {
      if (fieldLoss) {
        fieldLoss.style.opacity = '1';
      }
      const elem1 = document.getElementById('loss-toggle-wks');
      if (elem1) {
        elem1.className = 'mat-slide-toggle toggle-on';
      }
      const elem2 = document.getElementById('gain-toggle-wks');
      if (elem2) {
        elem2.className = 'mat-slide-toggle toggle-off';
      }
      if (fieldGain) {
        fieldGain.style.opacity = '0.5';
      }
      this.gainTrigger = true;
      this.gainLimit = true;
    } else {
      if (this.stopGain) {
        const elem = document.getElementById('gain-toggle-wks');
        if (elem) {
          elem.className = 'mat-slide-toggle toggle-on';
        }
        if (fieldGain) {
          fieldGain.style.opacity = '1';
        }
        this.tooltipValidator();
      } else {
        const elem = document.getElementById('gain-toggle-wks');
        if (elem) {
          elem.className = 'mat-slide-toggle toggle-off';
        }
        if (fieldGain) {
          fieldGain.style.opacity = '0.5';
        }
        this.gainTrigger = true;
        this.gainLimit = true;
      }
    }
    this.model.stopLoss = this.stopLoss;
    this.model.stopGain = this.stopGain;
    this.setMessagesStop();
  }

  setMessagesStop() {
    if (this.isBuy) {
      this.messageStopLoss = Constants.BILLET_ORDER_STOP_BUY_LOSS;
      if (this.isOrderStopSimultaneous) {
        this.messageStopGain = Constants.BILLET_ORDER_STOP_BUY_GAIN;
      } else {
        this.messageStopGain = Constants.BILLET_ORDER_OCO_STOP_BUY_GAIN;
      }
    } else {
      this.messageStopLoss = Constants.BILLET_ORDER_STOP_SELL_LOSS;
      if (this.isOrderStopSimultaneous) {
        this.messageStopGain = Constants.BILLET_ORDER_STOP_SELL_GAIN;
      } else {
        this.messageStopGain = Constants.BILLET_ORDER_OCO_STOP_SELL_GAIN;
      }
    }
  }

  validLoggedNegotiation() {
    if (!this.model.quote) {
      this._notificationService.warn('', this.msgQuoteInvalid);
      return false;
    } else if (!this.isLoggedNegotiation) {
      this._notificationService.warn('', this.msgOffline);
      this._sidebarService._clickOpenTabLoginBroker.next(true);
      return false;
    }
    return true;
  }

  checkMarketType() {
    this.model.type = this.checkMarket ? TypeOrderEnum.MARKET : TypeOrderEnum.LIMITED;
    this.typeOrder = this.model.type;
  }

}
